import { Injectable } from '@angular/core';
import { AccessoryCharge } from '@cargos/sprintpay-models';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { PaymentCartTypeDescription, PaymentCartTypeType } from '../../models/payment-type';

export interface AccessoriesFilters {
    paymentCartType?: PaymentCartTypeType;
}

@Injectable()
export abstract class AccessoriesService {
    private _accessories: BehaviorSubject<AccessoryCharge[]> = new BehaviorSubject<AccessoryCharge[]>([]);

    abstract fetchAccessories(destination?: string): Observable<AccessoryCharge[]>;

    setAccesories(accessories: AccessoryCharge[]): void {
        this._accessories.next(accessories);
    }

    getAccessories$(filters?: AccessoriesFilters): Observable<AccessoryCharge[]> {
        return this._accessories.asObservable().pipe(
            map((accessories) => {
                if (filters?.paymentCartType !== PaymentCartTypeType.NONE && filters?.paymentCartType != null) {
                    return this.filterAccessoriesByPaymentCartType(accessories, filters);
                }

                return accessories;
            })
        );
    }

    getAccesoryById(id: number): Observable<AccessoryCharge | undefined> {
        return this.getAccessories$().pipe(
            map((accessories: AccessoryCharge[]) => accessories.find((accessory) => accessory.id === id))
        );
    }

    getAccesoryByPaymentType(paymentType: string): Observable<AccessoryCharge | undefined> {
        return this.getAccessories$().pipe(
            map((accessories: AccessoryCharge[]) =>
                accessories.find((accessory) => accessory.paymentType === paymentType)
            )
        );
    }

    sortAccessoriesByType(accessories: AccessoryCharge[]): AccessoryCharge[] {
        return accessories.sort((a, b) => (a.isPrimary === b.isPrimary ? 0 : a.isPrimary ? -1 : 1));
    }

    filterAccessoriesWithOutRate(accessories: AccessoryCharge[]): AccessoryCharge[] {
        return accessories.filter((accessory) => {
            if (!accessory.isFreeForm) {
                return accessory.rate !== 0;
            }
            return accessory;
        });
    }

    getAccessoryRateByPaymentType(paymentType: string): Observable<number | null> {
        return this.getAccessories$().pipe(
            map((accessories: AccessoryCharge[]) => {
                const accesory = accessories.find((accessory) => accessory.paymentType === paymentType);

                return accesory ? (accesory.isFreeForm ? null : accesory.rate || null) : null;
            })
        );
    }

    filterAccessoriesByPaymentCartType(
        accessories: AccessoryCharge[],
        filters?: AccessoriesFilters
    ): AccessoryCharge[] {
        return accessories.filter((accessory: AccessoryCharge) => {
            if (
                filters?.paymentCartType != null &&
                (accessory.visible == null ||
                    accessory.visible === PaymentCartTypeDescription[filters?.paymentCartType]?.toUpperCase())
            ) {
                return true;
            }

            return false;
        });
    }
}
